// Avisa o servidor quando o usuário de fato mexe na tela. É isso que alimenta o
// "ocioso" da supervisão: chamadas automáticas (atualização de mapa, listas)
// não contam, e eventos que o navegador gera sozinho também não.
//
// Para investigar o que está contando como atividade, no console da aba:
//   localStorage.setItem('debugActivity', '1')   (e recarregar)
const MIN_INTERVAL_MS = 20000
const MIN_MOUSE_DELTA_PX = 4
// Teclas que sozinhas não são "usar o sistema" (ex.: o Alt do Alt+Tab chega na janela que está saindo).
const MODIFIER_KEYS = ['Alt', 'AltGraph', 'Control', 'Shift', 'Meta', 'OS', 'CapsLock', 'ContextMenu']

let started = false
let lastSentAt = 0
let pendingTimer = null
let lastInteractionAt = Date.now()
let lastX = null
let lastY = null

const debug = () => localStorage.getItem('debugActivity') === '1'

const SHARED_KEY = 'lastInteractionAt'
const SHARED_WRITE_MS = 1000
let sharedWrittenAt = 0

// O servidor conta a atividade do usuário em qualquer aba; por isso o "ocioso" que a própria
// aba mostra também considera a interação das outras abas (compartilhada via localStorage).
function readShared() {
  try {
    return Number(localStorage.getItem(SHARED_KEY)) || 0
  } catch (e) {
    return 0
  }
}

function writeShared(now) {
  if (now - sharedWrittenAt < SHARED_WRITE_MS) return
  sharedWrittenAt = now
  try {
    localStorage.setItem(SHARED_KEY, String(now))
  } catch (e) {
    // sem localStorage: vale só a interação desta aba
  }
}

/** Momento da última interação real do usuário, em qualquer aba (para o próprio operador ver o ocioso). */
export function getLastInteractionAt() {
  return Math.max(lastInteractionAt, readShared())
}

function isRealInteraction(event) {
  // Eventos sintéticos (disparados por script) nunca contam.
  if (!event.isTrusted) return false

  switch (event.type) {
    case 'mousedown':
    case 'touchstart':
      return true

    case 'wheel':
      return document.hasFocus()

    case 'mousemove': {
      // O navegador repete mousemove quando o conteúdo muda sob um mouse parado,
      // sempre nas mesmas coordenadas: só conta se o mouse andou de verdade.
      if (!document.hasFocus()) return false
      const moved = lastX === null || Math.abs(event.clientX - lastX) + Math.abs(event.clientY - lastY) >= MIN_MOUSE_DELTA_PX
      if (moved) {
        lastX = event.clientX
        lastY = event.clientY
      }
      return moved
    }

    case 'keydown':
      return !MODIFIER_KEYS.includes(event.key) && !event.altKey && !event.metaKey

    default:
      return false
  }
}

export function startActivityTracker(getApiUrl) {
  if (started) return
  started = true

  // Manda o aviso com a idade da interação (idle_ms): assim o servidor grava a hora
  // em que o usuário mexeu, não a de quando o aviso saiu.
  const send = () => {
    pendingTimer = null
    if (!localStorage.getItem('token')) return

    lastSentAt = Date.now()
    window.axios
      .post(`${getApiUrl()}presence/heartbeat`, { idle_ms: Math.max(0, Date.now() - lastInteractionAt) })
      .catch(() => {
        // Falhou: libera a próxima interação para tentar de novo.
        lastSentAt = 0
      })
  }

  const onInteraction = event => {
    if (!isRealInteraction(event)) return

    const now = Date.now()
    lastInteractionAt = now
    writeShared(now)

    if (debug()) console.log('[activity]', event.type, event.key || `${event.clientX},${event.clientY}`)

    const sinceLastSend = now - lastSentAt
    if (sinceLastSend >= MIN_INTERVAL_MS) {
      send()
    } else if (!pendingTimer) {
      // Interação dentro da janela: o último movimento ainda precisa chegar ao servidor.
      pendingTimer = setTimeout(send, MIN_INTERVAL_MS - sinceLastSend)
    }
  }

  ;['mousemove', 'mousedown', 'keydown', 'wheel', 'touchstart'].forEach(name =>
    window.addEventListener(name, onInteraction, { passive: true, capture: true }),
  )
}
